module.exports = __webpack_public_path__ + "img/servired-alternate.c97d66aa.png";